import { render, staticRenderFns } from "./StudentListActions.vue?vue&type=template&id=3fa7df16"
import script from "./StudentListActions.vue?vue&type=script&lang=js"
export * from "./StudentListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports